import { render, staticRenderFns } from "./UpdateFormulario.vue?vue&type=template&id=74122cd5&scoped=true"
import script from "./UpdateFormulario.vue?vue&type=script&lang=js"
export * from "./UpdateFormulario.vue?vue&type=script&lang=js"
import style0 from "./UpdateFormulario.vue?vue&type=style&index=0&id=74122cd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74122cd5",
  null
  
)

export default component.exports